import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import React, { ReactNode } from "react"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Processes text containing markdown-style bold syntax (**text**) and converts it to JSX elements
 */
export function processMarkdownBold(text: string): ReactNode[] {
  if (!text.includes('**')) {
    return [text]
  }

  const parts = text.split('**')
  const result: ReactNode[] = []
  
  parts.forEach((part, index) => {
    if (index === 0) {
      // First part is always regular text
      if (part) result.push(part)
    } else if (index % 2 === 1) {
      // Odd indices are bold text (between **)
      if (part) result.push(React.createElement('strong', { key: `bold-${index}` }, part))
    } else {
      // Even indices (after first) are regular text
      if (part) result.push(part)
    }
  })
  
  return result
}
